import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const ChatMessage = ({ message }) => {
    const theme = useTheme();
    const messageDateTime = new Date(message.date).toLocaleString([], {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
            <Paper
                elevation={1}
                sx={{
                    maxWidth: '70%',
                    p: 1.5,
                    bgcolor: theme.palette.background.paper,
                    borderRadius: '12px 12px 12px 0',
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                }}
            >
                <Typography variant="caption" sx={{ display: 'block', textAlign: 'left', mb: 0.5, color: 'text.secondary' }}>
                    {messageDateTime}
                </Typography>
                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {message.chat_message}
                </Typography>
            </Paper>
        </Box>
    );
};

export default ChatMessage;
